<template lang="pug">
    .z-rl-freight-container(v-if="freight && freight.id")
        .z-rl-freight(v-bind:class="{'active': isOpen, 'has-error': ($props.error && $props.error.length)}")
            .z-rl-freight-close(v-on:click="remove" v-if="$props.showRemove")
                md-icon clear
            .z-rl-freight-divider(v-if="sortedRouteList && sortedRouteList.length")
            .z-rl-freight__left(v-bind:class="{'full': (!sortedRouteList || !sortedRouteList.length)}")
                .z-rl-freight__top
                    .z-rl-freight__left__left
                        .z-rl-freight__left__number
                            span {{freight.traking_number}}
                            span(v-if="hasDoom") *
                        .z-rl-freight__left__dimensions
                            span.z-rl-freight__left__dimension.weight {{ `${realWeight}кг` }}
                            span.z-rl-freight__left__dimension.volume
                                span {{ realVolume }}
                                span м<sup>3</sup>
                            span.z-rl-freight__left__dimension.seats {{ `${realSeats}` }}
                        .z-rl-freight__left__status(v-if="freight.status" v-bind:style="'color: ' + freight.status.color + ';'") {{freight.status.name}}
                        .z-rl-freight__left__forward-method(v-if="$props.showForwardTypeLabel && forwardMethodLocal") {{forwardMethodLocal}}

                    .z-rl-freight__left__center
                        .z-rl-freight__left__from
                            .label Откуда: 
                            .value(v-if="!freight.deal.from_address_id && freight.deal && freight.deal.from_stock") {{freight.deal.from_stock.name}}
                            .value(v-if="freight.deal.from_address_id && freight.deal && freight.deal.from_address") {{freight.deal.from_address.address}}

                        .z-rl-freight__left__to
                            .label Куда:
                            .value(v-if="!freight.deal.to_address_id && freight.deal && freight.deal.to_stock") {{freight.deal.to_stock.name}}
                            .value(v-if="freight.deal.to_address_id && freight.deal && freight.deal.to_address") {{freight.deal.to_address.address}}
                
                .z-rl-freight__bottom(v-if="isOpen && freight.deal_id")
                    z-deal-view(v-bind:deal-id="parseInt(freight.deal_id)")

            .z-rl-freight__center(v-if="sortedRouteList && sortedRouteList.length")
                .z-rl-freight__center__roulte-lists
                    router-link.z-rl-freight__center__roulte-list(
                        v-for="(routeList, i) in sortedRouteList"
                        v-if="(i <= 2 || isOpen)"
                        v-bind:to="{name: ($props.storekeeperView ? 'StorekeepersItinerary' : 'Itinerary'), props: {id: routeList.id}}"
                        v-bind:key="('rl-' + i + '-' + routeList.id)"
                        v-bind:style="'color: ' + getStatusColor(routeList) + ';'"
                    )
                        .z-rl-freight__center__roulte-field.z-rl-freight__center__roulte-list__id
                            .value(v-if="routeList.id") {{routeList.id}}
                        .z-rl-freight__center__roulte-field.z-rl-freight__center__roulte-list__type
                            .value(v-if="routeList.type_name") {{routeList.type_name}}
                        .z-rl-freight__center__roulte-field.z-rl-freight__center__roulte-list__name 
                            .value(v-if="routeList.status && routeList.status.message") {{routeList.status.message}}
            .z-rl-freight__right(v-bind:class="{'active': isOpen}")
                .z-rl-freight__toggle-btn(v-bind:class="{'active': isOpen}" v-on:click="toggle")
                    i.fas.fa-chevron-down

        .z-rl-freight-errors(v-if="$props.error && $props.error.length")
            .z-rl-freight-error(v-for="(error, i) in $props.error" v-bind:key="('error-' + freight.id + '-' + i)")
                md-icon error_outline
                span.z-rl-freight-error__text {{error}}

        .z-rl-freight-warnings(v-if="$props.warning && $props.warning.length")
            .z-rl-freight-warning(v-for="(warning, i) in $props.warning" v-bind:key="('error-' + freight.id + '-' + i)")
                md-icon error_outline
                span.z-rl-freight-warning__text {{warning}}

                
</template>
<script>
    import ZDealView from './ZDealView';
    export default {
        name: 'z-rl-freight',
        components: {ZDealView},
        props: {
            freight: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            error: {
                type: Array,
                default: () => {
                    return []
                }
            },
            warning: {
                type: Array,
                default: () => {
                    return []
                }
            },
            showRemove: {
                type: Boolean,
                default: false
            },
            storekeeperView: {
                type: Boolean,
                default: false
            },
            forwardMethod: {
                type: Number,
                default: 0
            },
            showForwardTypeLabel: {
                type: Boolean,
                default: false
            },
            doomMarkup: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                isOpen: false
            }
        },
        created() {},
        watch: {},
        computed: {
            sortedRouteList() {
                if (!this.$props.freight || !this.$props.freight.route_lists) return [];
                return this.$props.freight.route_lists.sort((a, b) => (parseInt(a.status_id) - parseInt(b.status_id)));
            },
            forwardMethodLocal() {
                if (!this.forwardMethod || parseInt(this.forwardMethod) === 0) return;
                if (parseInt(this.forwardMethod) === 1) return 'Забор';
                if (parseInt(this.forwardMethod) === 2) return 'Выдача';
                return;
            },
            hasDoom() {
                return this.$props.freight && parseInt(this.$props.freight.doom) === 1
            },
            realWeight() {
                let v = 0;
                if (!this.$props.freight) return v;
                v = this.$props.freight.weight;
                if (parseInt(this.$props.freight.doom) === 1 && this.$props.doomMarkup > 0) 
                    v = parseFloat(this.$props.freight.weight) + ((parseFloat(this.$props.freight.weight) * this.$props.doomMarkup) / 100);
                
                return this.round(v).toFixed(2)
            },
            realVolume() {
                let v = 0;
                if (!this.$props.freight) return v;
                v = this.$props.freight.size;
                if (parseInt(this.$props.freight.doom) === 1 && this.$props.doomMarkup > 0) 
                    v = parseFloat(this.$props.freight.size) + ((parseFloat(this.$props.freight.size) * this.$props.doomMarkup) / 100);
                
                return this.round(v).toFixed(2)
            },
            realSeats() {
                return parseInt(this.$props.freight.seats_number);
            }
        },
        methods: {
            remove() {
                this.$emit('remove');
            },
            toggle() {
                this.isOpen = !this.isOpen;
            },
            getStatusColor(routeList) {
                return (routeList.status && routeList.status.message && routeList.status.color) ? routeList.status.color : '#000';
            },
            round(num, decimals = 2) {
                const factor = Math.pow(10, decimals);
                return Math.round(num * factor) / factor;
            },
        }
    }
</script>
<style lang="sass">
    .z-rl-freight-container + .z-rl-freight-container
        margin: 15px 0 0 0
    .z-rl-freight-container
        .z-rl-freight-errors
            padding: 5px 0 0 0
            .z-rl-freight-error
                display: flex
                align-items: center
                justify-content: flex-start
                .md-icon
                    margin: 0 5px 0 0
                    font-size: 22px !important
                    width: 22px
                    height: 22px
                    color: red !important
                .z-rl-freight-error__text
                    font-size: 12px
                    line-height: 14px
                    color: red
        .z-rl-freight-warnings
            padding: 5px 0 0 0
            .z-rl-freight-warning
                display: flex
                align-items: center
                justify-content: flex-start
                .md-icon
                    margin: 0 5px 0 0
                    font-size: 22px !important
                    width: 22px
                    height: 22px
                    color: #2196f3 !important
                .z-rl-freight-warning__text
                    font-size: 12px
                    line-height: 14px
                    color: #2196f3
    .z-rl-freight
        display: flex
        align-items: flex-start
        justify-content: flex-end
        border: 1px solid #E5E5E5
        border-radius: 3px
        font-size: 12px
        line-height: 14px
        position: relative
        transition: 0.2s ease-in-out
        background: #fff
        height: 84px
        &:hover
            border-color: #BEBEBE
            box-shadow: 3px 3px 4px 0px rgba(0, 0, 0, 0.1)
            .z-rl-freight-divider
                background: #BEBEBE
            .z-rl-freight-close
                opacity: 1
        &.active
            height: auto
        &.has-error
            border-color: red
            .z-rl-freight-divider
                background: red
        .z-rl-freight-close
            display: flex
            align-items: center
            justify-content: center
            width: 22px
            height: 22px
            opacity: 0
            position: absolute
            top: -11px
            right: -11px
            background: rgba(255, 49, 49, 0.91)
            border-radius: 100%
            transition: 0.2s ease-in-out
            cursor: pointer
            .md-icon
                color: #fff
                width: 16px
                height: 16px
                min-width: 16px
                font-size: 16px !important
        .z-rl-freight-divider
            position: absolute
            width: 1px
            height: 100%
            top: 0
            right: 365px
            background: #E5E5E5
            transition: 0.2s ease-in-out
        .z-rl-freight__left
            padding: 10px
            height: 100%
            flex-shrink: 1
            margin: auto auto auto 0
            width: calc(100% - 365px)
            position: relative
            &.full
                width: calc(100% - 45px)
            .z-rl-freight__top
                display: flex
                align-items: flex-start
                justify-content: flex-start
                .z-rl-freight__left__left
                    display: flex
                    flex-direction: column
                    align-items: flex-start
                    justify-content: space-between
                    width: 140px
                    flex-shrink: 0
                    .z-rl-freight__left__number
                        font-weight: bold
                    .z-rl-freight__left__status
                .z-rl-freight__left__forward-method
                    background-color: rgba(255, 0, 0, 0.8)
                    color: #fff
                    padding: 2px 4px
                    border-bottom-left-radius: 3px
                    border-top-right-radius: 3px
                    position: absolute
                    bottom: 0
                    left: 0
                .z-rl-freight__left__dimensions
                    display: flex
                    align-items: baseline
                    justify-content: space-between
                    width: 100%
                    .z-rl-freight__left__dimension
                        &.weight
                            width: calc(50% - 24px/2)
                        &.volume
                            width: calc(50% - 24px/2)
                        &.seats
                            width: 24px
                .z-rl-freight__left__center
                    display: flex
                    flex-direction: column
                    align-items: flex-start
                    justify-content: space-between
                    margin: 0 15px
                    .z-rl-freight__left__from
                        margin: 0 0 5px 0
                    .z-rl-freight__left__from, .z-rl-freight__left__to
                        display: flex
                        align-items: flex-start
                        justify-content: flex-start
                        .value
                            height: 28px
                            width: 100%
                            overflow: hidden
                    .label
                        color: #666666
                        width: 55px
                        flex-shrink: 0
                    .value
                .z-rl-freight__left__right
            .z-rl-freight__bottom
                border-top: 1px solid #BEBEBE
                margin: 10px -10px 0 -10px
                padding: 0 10px 0 10px
        .z-rl-freight__center
            padding: 5px 0
            height: 100%
            width: 320px
            flex-shrink: 0
        .z-rl-freight__center__roulte-lists
            display: flex
            flex-direction: column
            align-items: flex-start
            justify-content: flex-start
            .z-rl-freight__center__roulte-list
                display: flex
                align-items: center
                justify-content: flex-start
                width: 100%
                padding: 5px 0 5px 15px
                text-decoration: none !important
                .z-rl-freight__center__roulte-field
                    .value
                        font-weight: bold
                        font-size: 12px
                        line-height: 14px
                .z-rl-freight__center__roulte-list__id
                    flex-shrink: 0
                    text-align: left
                    width: 55px
                    .value
                        display: block
                        width: 100%
                        white-space: nowrap
                        overflow: hidden
                        text-overflow: ellipsis
                .z-rl-freight__center__roulte-list__type
                    flex-shrink: 0
                    margin: 0 5px 0 5px
                    text-align: left
                    .value
                        font-weight: normal
                .z-rl-freight__center__roulte-list__name 
                    flex-shrink: 1
                    text-align: right
                    margin: auto 0 auto auto
        .z-rl-freight__right
            display: flex
            align-items: center
            justify-content: center
            padding: 10px
            flex-shrink: 0
            width: 45px
            height: 84px
            .z-rl-freight__toggle-btn
                display: flex
                align-items: center
                justify-content: center
                width: 25px
                height: 25px
                border: 2px solid #2196F3
                color: #2196F3
                background: #fff
                border-radius: 100%
                cursor: pointer
                transition: 0.2s ease-in-out
                &:hover, &.active
                    color: #fff
                    background: #2196F3
                &.active
                    transform: rotate(180deg)
</style>


// WEBPACK FOOTER //
// ZRLFreight.vue?07788c58